import { Drawer, Grid, Typography, Divider } from '@material-ui/core';
import { Button, SmSpace } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import RemoveIcon from '@material-ui/icons/Remove';
import Edit from '@material-ui/icons/Edit';
import Add from '@material-ui/icons/Add';
import { Custodiante, InformacoesBancariasCustodiante } from 'common/genericTypes';

interface Props {
  open: boolean;
  custodiante: Custodiante | null;
  onClose: () => void;
  removeDadosBancarios: (informacoesBancarias?: InformacoesBancariasCustodiante) => void;
  isEdit: boolean;
  dadosBancarios: (value: Custodiante, isEdit: boolean) => void;
}



const InformacoesBancariasListDrawer: React.FC<Props> = (props) => {
  const { open, custodiante, isEdit, onClose, removeDadosBancarios, dadosBancarios } = props;

  const handleClose = () => {
    onClose();
  };

  const [hasInformacoesBancarias, setHasInformacoesBancarias] = useState<boolean>(false);

  const verifyInformacoesBancarias = () => {
    const hasInformacoes = custodiante?.informacoesBancarias?.some(informacoesBancarias => informacoesBancarias.agenciaBanco.length > 0);
    setHasInformacoesBancarias(hasInformacoes as boolean);
  }

  useEffect(() => {
    verifyInformacoesBancarias();
  }, [custodiante]);

  return (
    <Drawer open={open} onClose={handleClose} PaperProps={{ style: { padding: '40px', width: 465 } }} anchor="right">
      <Typography variant="h3">{'Dados Bancários do Custodiante'}</Typography>
      <Typography variant="body2">{custodiante?.razaoSocialInstituicaoCustodiante}</Typography>
      <SmSpace />
      <Divider variant="fullWidth" />
      <SmSpace />
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid item xs={12}>
          
          {custodiante !== null && (custodiante?.informacoesBancarias == undefined || custodiante?.informacoesBancarias?.length === 0 || !hasInformacoesBancarias) && (
            <><Typography variant="body1">{'Nenhum dado bancário cadastrado'}</Typography>
            <Grid item xs={10} style={{ display: 'initial', margin: 10 }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<Add />}
                onClick={() => {
                  handleClose();
                  dadosBancarios(custodiante, false);
                }}
                style={{ width: '100%', marginTop: 20 }}
              >
                {'Adicionar dados Bancários	'}
              </Button>
            </Grid></>
          )}
          {custodiante?.informacoesBancarias?.map((bank) => {
            return (
              <>
                <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
                  {bank.ispbBanco.length > 0 && (
                  <Grid item xs={10}>
                    <Typography variant="body1">{'ISPB'}</Typography>
                    <Typography variant="body2">{bank.ispbBanco}</Typography>
                    <Typography variant="body1">{'Razão Social'}</Typography>
                    <Typography variant="body2">{bank.razaoSocialBanco}</Typography>
                    <Typography variant="body1">{'Agência'}</Typography>
                    <Typography variant="body2">{bank.agenciaBanco}</Typography>
                    <Typography variant="body1">{'Conta'}</Typography>
                    <Typography variant="body2">{bank.contaBanco}</Typography>
                  </Grid>
                  )}
                  {bank.ispbBanco.length > 0 && (
                    <>
                    <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          removeDadosBancarios(bank);
                        } }
                        style={{ minWidth: '0', maxWidth: '45px', width: '45px', height: '60px', borderRadius: '50%' }}
                      >
                        <RemoveIcon />
                      </Button>
                    </Grid>
                    <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 10 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            dadosBancarios(custodiante, true);
                          } }
                          style={{ minWidth: '0', maxWidth: '45px', width: '45px', height: '60px', borderRadius: '50%' }}
                        >
                          <Edit />
                        </Button>
                    </Grid>
                    </>
                  )}
                </Grid>
                <SmSpace />
              </>
            );
          })}
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default InformacoesBancariasListDrawer;
